// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gwgo","newExpiryDate":"styles_newExpiryDate__2xz5l","footer":"styles_footer__2HJnc"};